import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRevolutComponent } from './simple-icons-revolut.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRevolutComponent ],
    exports:      [ SimpleIconsRevolutComponent ],
    bootstrap:    []
})
export class SimpleIconsRevolutModule {}
